import React from 'react';

/** Lazy ClientComputedSurvey (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedSurvey = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-survey' */
            './ClientComputedSurvey'
        ),
);
